<template>
	<div class="convention-hall page">
		<van-nav-bar class="nav-bar" title="選妃" />
		<div class="convention-item">
			<van-tabs animated sticky line-width="100px" :swipeable="true">
				<van-tab title="城市大全">
					<div class="card">本平台全網最真實的外圍+商務伴遊+同城激情，為保障每位用戶的個人隱私，客戶需聯繫接待員或平台資深會員，通過實名推薦方可加入。</div>
					<div class="address">
						<div v-for="(val, key) in addlist" :key="key">
							<div class="city-item" @click="addgo(v)" v-for="(v, k) in val" :key="k">{{ v.name }}</div>
						</div>
					</div>
				</van-tab>
				<van-tab title="流程價格">
					<div class="card">本平台全網最真實的外圍+商務伴遊+同城激情，為保障每位用戶的個人隱私，客戶需聯繫接待員或平台資深會員，通過實名推薦方可加入。</div>
					<div class="rig-box">
						<p class="rig-title">有什麼資源？</p>
						<p class="rig-content">網紅、模特、空姐、戀慕、在校大學生，你能想到的這裡都有，平台沒有的你也找不到</p>
						<p class="rig-title">服務範圍？</p>
						<p class="rig-content">同城免費約，隨時隨地全國空降，一二線城市本地均有，三線城市可聯繫接待員預約</p>
						<p class="rig-content">本平台全網最真實的外圍+商務伴遊+同城激情，為保障每位用戶的個人隱私，客戶需聯繫接待員或平台資深會員，通過實名推薦方可加入。</p>
					</div>
				</van-tab>
			</van-tabs>
		</div>
	</div>
</template>

<script>
export default {
  name: 'ChooseIndex',
  data() {
    return {
		addlist: [
			{
				0: '北京',
				1: '上海',
				2: '广州',
				3: '深圳'
			},
			{
				0: '南京',
				1: '长沙',
				2: '重庆',
				3: '西安'
			}
		]
    }
  },
	methods: {
		addgo(data) {
			if (!localStorage.getItem('token')) {
				this.$router.push({ path: '/Login' });
			} else {
				this.$router.push({ path: '/list?id=' + data.id + '&name=' + data.name });
			}
		},
		getAddress() {
			this.$http({
				method: 'get',
				url: 'address_list'
			}).then(res => {
				this.addlist = res.data;
			});
		}
	},
	created() {
		this.getAddress();
	}
};
</script>

<style lang="less" scoped>
.page {
	position: absolute !important;
	top: 0;
	left: 0;
	right: 0;
	background-color: #f2f2f5;
}
.nav-bar {
	background: linear-gradient(90deg, #7e5678, #e6c3a1);
	height: 100px;
}
.van-nav-bar {
	line-height: 50px;
}
::v-deep .van-nav-bar__title {
	max-width: 60%;
	margin: 0 auto;
	color: #ffffff;
	font-size: 35px;
}
::v-deep .van-nav-bar__content {
	height: 100px;
}
.van-sidebar {
	width: 180px;
}
// /deep/ .van-col{
	// padding: 30px 0px;
// }
.convention-hall {
	display: flex;
	flex-direction: column;
	bottom: 20px;
	background: #f2f2f5;
}
::v-deep .van-tab {
	font-size: 30px;
	line-height: 100px;
	font-weight: bold;
}
::v-deep .van-tabs__line {
	background-color: #7e5678;
}
::v-deep .van-tabs--line .van-tabs__wrap {
	height: 100px;
}
::v-deep .van-tabs__wrap--scrollable .van-tab {
	padding: 0 23px;
}
.card {
	background-color: #8a637d;
	padding: 0.625rem;
	width: 95%;
	color: white;
	font-size: 0.8125rem;
	margin: 0.625rem auto;
	border-radius: 0.375rem;
}
::v-deep .van-row--flex {
	height: 80px;
	line-height: 80px;
}

/deep/ .van-cell{
	padding: 30px 22px;
	font-size: 30px;
	line-height:30px;
}
.rig-box {
	width: 95%;
	margin: 0.625rem auto;
}
.rig-title {
	color: #0bdab0;
	font-size: 1.125rem;
}
.rig-content {
	font-size: 20px;
	// margin-top: 10px;
}
.address {
	width: 94%;
	margin: 0 auto;
	background: url('/img/mine/img2.jpg') center center no-repeat;
	background-size: cover;
	overflow-y: auto;
	max-height: 67vh;
}
.city-item {
	width: 100%;
	padding: 20px 0;
	font-size: 30px;
	color: #333;
	text-align: left;
	cursor: pointer;
	background: transparent;
	padding-left: 20px;
}
</style>
